import { readAndMergeTranslations } from './base'

export default { ...readAndMergeTranslations('en') }
